<div class="options-row-container">
  <div class="me-auto d-flex align-items-center gap-3">
    <lib-filter-button [badgeCount]="filtersBadgeCount()" (buttonClick)="filtersClicked()" i18n>
      Filters
    </lib-filter-button>
    @if (searchesBadgeCount() ?? 0 > 0) {
      <lib-filter-button
        [hideLeadingIcon]="true"
        [badgeCount]="searchesBadgeCount()"
        (buttonClick)="clearSearchesClick.emit()"
        i18n>
        Clear Searches
      </lib-filter-button>
    }
  </div>
  <lib-viewing-rows-dropdown
    [pageSizeOptions]="pageSizeOptions()"
    (viewingRowCount)="viewingRowCount.emit($event)">
  </lib-viewing-rows-dropdown>
  <lib-button
    [type]="ButtonType.secondary"
    [trailingIconName]="'file-export'"
    [disabled]="!hasData()"
    (buttonClick)="exportToCSVClicked()"
    i18n>
    Export to CSV
  </lib-button>
</div>
